import { Box, FormLabel } from '@chakra-ui/react';
import CheckboxSelect from 'components/ui/CheckboxSelect/CheckboxSelect';
import { useResourceList } from 'hooks/useResourceList';
import { useFiltersListContext } from '../contexts/FiltersListContext';

export default function Filters() {
  const { data: companies } = useResourceList({
    resourceName: 'companies',
  });

  const { data: tags } = useResourceList({
    resourceName: 'tags',
    path: 'tags/LIST',
  });

  const { dispatch, state } = useFiltersListContext();

  const selectedCustomerIds = state.companies ?? [];
  const selectedTagIds = state.tags ?? [];

  const companyOptions = companies?.map((c) => ({
    value: c.id,
    label: c.name,
  }));
  const tagOptions = tags?.map((t) => ({ value: t.id, label: t.name }));

  return (
    <>
      <Box>
        <FormLabel>Filtrar por cliente</FormLabel>
        <CheckboxSelect
          placeholder="Todos os clientes"
          options={companyOptions}
          onChange={(value) =>
            dispatch({ name: 'companies', value: value?.map((v) => v.value) })
          }
          value={companyOptions?.filter((c) =>
            selectedCustomerIds.includes(c.value)
          )}
        />
      </Box>
      <Box>
        <FormLabel>Filtrar por tag</FormLabel>
        <CheckboxSelect
          placeholder="Todos as tags"
          options={tagOptions}
          onChange={(value) =>
            dispatch({ name: 'tags', value: value?.map((v) => v.value) })
          }
          value={tagOptions?.filter((t) => selectedTagIds.includes(t.value))}
        />
      </Box>
    </>
  );
}
